// generated by genversion
const version = '6.15.4';

export { version };
//# sourceMappingURL=version.mjs.map
